/*!
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

export { default as AccordionCleanItems } from './accordion-clean-items-expanded.story';
export { default as AccordionDefault } from './accordion-default-expanded.story';
export { default as AccordionFull } from './accordion-full.story';
export { default as AccordionMultipleExpanded } from './accordion-multiple-expanded.story';
export { default as AccordionRightContent } from './accordion-right-content.story';
export { default as AccordionSingleExpanded } from './accordion-single-expanded.story';

import { removeLicenseHeader } from '../../_common/export-stories-utils';
import AccordionCleanItemsSrcRaw from './accordion-clean-items-expanded.story?raw';
import AccordionDefaultSrcRaw from './accordion-default-expanded.story?raw';
import AccordionFullSrcRaw from './accordion-full.story?raw';
import AccordionMultipleExpandedSrcRaw from './accordion-multiple-expanded.story?raw';
import AccordionRightContentSrcRaw from './accordion-right-content.story?raw';
import AccordionSingleExpandedSrcRaw from './accordion-single-expanded.story?raw';

export const AccordionCleanItemsSrc = removeLicenseHeader(
  AccordionCleanItemsSrcRaw,
);
export const AccordionDefaultSrc = removeLicenseHeader(AccordionDefaultSrcRaw);
export const AccordionFullSrc = removeLicenseHeader(AccordionFullSrcRaw);

export const AccordionMultipleExpandedSrc = removeLicenseHeader(
  AccordionMultipleExpandedSrcRaw,
);
export const AccordionRightContentSrc = removeLicenseHeader(
  AccordionRightContentSrcRaw,
);

export const AccordionSingleExpandedSrc = removeLicenseHeader(
  AccordionSingleExpandedSrcRaw,
);
